import secureApi from "../services/secureApi";
export const getCategories = async () => {
  try {
    const response = await secureApi.get("/admin/category/list");
    return response.data;
  } catch (error) {
    console.error("Error fetching categories:", error);
    return [];
  }
};
export const getCategoryById = async (slug) => {
  try {
    const response = await secureApi.get(`/category/view/${slug}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching category:", error);
    return null;
  }
};
export const createCategory = async (data) => {
  try {
    const response = await secureApi.post(
      "/admin-upload/category/add",
      data
    );
    return response.data;
  } catch (error) {
    console.error("Error creating category:", error);
    throw error;
  }
};
export const updateCategory = async (id, data) => {
  try {
    const response = await secureApi.put(
      `/admin-upload/category/edit/${id}`,
      data
    );
    return response.data;
  } catch (error) {
    console.error("Error updating category:", error);
    throw error;
  }
};

export const exportCategories = async () => {
  const response = await secureApi.get(
    "/admin/category/export",
    {
      responseType: "blob",
    }
  );

  return response;
};
